import React, { useState, useContext, useEffect } from "react"
import _ from "lodash"

import { LoaderMedium } from "../../../components/Loaders"

import { FirebaseContext } from "../../../firebase"

import profileDummy from "../../../assets/images/default-profile-avatar.jpg"

export default function StaffProfilePhoto({
  staff_profile_image,
  className = "",
}) {
  const firebase = useContext(FirebaseContext)
  const [loading, setLoading] = useState(true)
  const [profileImageUrl, setProfileImageUrl] = useState("")

  useEffect(() => {
    const profileImage = staff_profile_image || ""

    const getProfileImageUrl = async (image) => {
      const { getStorage, ref, getDownloadURL } = firebase.storage
      const storage = getStorage()

      if (_.isEmpty(image)) {
        return profileDummy
      }

      try {
        const logoRef = ref(storage, image)
        return await getDownloadURL(logoRef)
      } catch (error) {
        console.error("Error fetching profile image URL: ", error)
        return profileDummy
      }
    }

    const fetchLogo = async () => {
      const imageUrl = await getProfileImageUrl(profileImage)
      setProfileImageUrl(imageUrl)
      setLoading(false)
    }

    fetchLogo()
  }, [firebase.storage, staff_profile_image])

  if (loading) return <LoaderMedium />

  return <img src={profileImageUrl} alt="Profile" className={className} />
}
